import React, { useState, useMemo } from "react";
import { FaTimes, FaSearch } from "react-icons/fa";
import { MdLocationOff } from "react-icons/md";
import "./UnavailableLocationsModal.scss";

interface UserLocation {
  id: string;
  latitude?: number;
  longitude?: number;
  updatedOn?: string;
}

interface UnavailableLocationsModalProps {
  users: UserLocation[];
  onClose: () => void;
}

const UnavailableLocationsModal: React.FC<UnavailableLocationsModalProps> = ({
  users,
  onClose,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredUsers = useMemo(() => {
    if (!searchTerm.trim()) return users;

    const search = searchTerm.toLowerCase();
    return users.filter((user) => user.id.toLowerCase().includes(search));
  }, [users, searchTerm]);

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="unavailable-modal-backdrop" onClick={handleBackdropClick}>
      <div className="unavailable-modal">
        <div className="unavailable-modal-header">
          <div className="unavailable-modal-title-section">
            <div className="unavailable-modal-icon">
              <MdLocationOff />
            </div>
            <div>
              <h2 className="unavailable-modal-title">Unavailable Locations</h2>
              <p className="unavailable-modal-subtitle">
                {users.length} team {users.length === 1 ? "member" : "members"}{" "}
                without location data
              </p>
            </div>
          </div>
          <button
            className="unavailable-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            <FaTimes />
          </button>
        </div>

        <div className="unavailable-modal-search">
          <div className="unavailable-search-wrapper">
            <FaSearch className="unavailable-search-icon" />
            <input
              type="text"
              className="unavailable-search-input"
              placeholder="Search by TM ID..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button
                className="unavailable-search-clear"
                onClick={() => setSearchTerm("")}
                aria-label="Clear search"
              >
                <FaTimes />
              </button>
            )}
          </div>
          {searchTerm && (
            <p className="unavailable-search-results">
              Found {filteredUsers.length}{" "}
              {filteredUsers.length === 1 ? "result" : "results"}
            </p>
          )}
        </div>

        <div className="unavailable-modal-content">
          {filteredUsers.length === 0 ? (
            <div className="unavailable-modal-empty">
              <MdLocationOff className="unavailable-empty-icon" />
              <p className="unavailable-empty-text">
                {searchTerm
                  ? "No tm's found matching your search"
                  : "No unavailable locations"}
              </p>
            </div>
          ) : (
            <div className="unavailable-users-list">
              {filteredUsers.map((user, index) => (
                <div key={user.id} className="unavailable-user-item">
                  <span className="unavailable-user-number">{index + 1}</span>
                  <span className="unavailable-user-id">{user.id}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="unavailable-modal-footer">
          <button className="unavailable-modal-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnavailableLocationsModal;
